var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M490.56,244.93,415.5,173.08V64.49a16,16,0,0,0-16-16h-48a16,16,0,0,0-16,16v32L277.67,41.14c-5.4-5.48-13.42-8.62-22.11-8.63s-16.78,3.12-22.21,8.61L20.44,244.93a16,16,0,1,0,22.12,23.12L63.5,248V448.49a32,32,0,0,0,32,32h96a16,16,0,0,0,16-16v-136a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v136a16,16,0,0,0,16,16h96a32,32,0,0,0,32-32V248l20.94,20a16,16,0,1,0,22.12-23.12ZM367.5,80.49h16v62l-16-15.32Zm48,368h-80v-120a40,40,0,0,0-40-40h-80a40,40,0,0,0-40,40v120h-80V217.38L255.18,64.52a3.42,3.42,0,0,1,.64,0L415.5,217.38Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWelcome);
export default __webpack_public_path__ + "static/media/icon-welcome.f48bffb9.svg";
export { ForwardRef as ReactComponent };